import React, {useEffect, useState} from "react";
import "styles/scss/login.scss";
import * as EgovNet from 'api/fetch';
import { getSessionItem } from "utils/storage";
import { useNavigate } from "react-router-dom";

function Account() {

    const navigate = useNavigate();
    
    // 세션값 id에 넣어주기
    const [id, setId] = useState('');
    const [password, setPassword] = useState(''); // 비밀번호 상태 추가
    const [userInfo, setUserInfo] = useState({ 'id' : '' , 'password' : '' });
    const [userList, setUserList] = useState([]); // 사용자 목록 상태 추가
    // 상태값 비교
    const [isChecked, setIsChecked] = useState(false);

    useEffect(() => {
        // 세션값 가져오기
        const sessionUser = getSessionItem('loginUser'); // 세션 값 확인    
        const userId = sessionUser.id; // 세션값에서 userId 가져오기
        if (userId !== "masteruser") {
            alert("접근 권한이 없습니다.");
            navigate("/psts"); // 권한이 없으면 홈으로 리다이렉트
            return;
        }

        // 사용자목록 가져오는 함수
        const getUserListUrl = "/api/getUserList";
        const requestOptions = {
            method: "GET",
            headers: {
                'Content-type': 'application/json'
            },
        };
        EgovNet.requestFetch(getUserListUrl, requestOptions, (resp) => {
            setUserList(resp.result.resultVO); // 사용자 목록 상태 업데이트
        });
    }, []);

    const createHandler = () => {
        const checkUrl = "/api/createUser";
        const requestOptions = {
            method: "POST",
            headers: {
                'Content-type': 'application/json'
            },
            body: JSON.stringify({userId: id, userPswd: password})
        };
        EgovNet.requestFetch(checkUrl, requestOptions, (resp) => {
            if (resp.resultCode === 200) {
                alert("등록되었습니다.")

            } else if (resp.resultCode === 400) {
                alert("이미 존재하는 아이디입니다.")
            } else {
                alert("등록에 실패하였습니다.")
            }
        });
    };

    const resetHandler = () => {
        const modifyUrl = "/api/updateUser";
        const requestOptions = {
            method: "POST",
            headers: {
                'Content-type': 'application/json'
            },
            body: JSON.stringify({userId: id, userPswd: 'ntek@321'})
        };
        EgovNet.requestFetch(modifyUrl, requestOptions, (resp) => {
            if (resp.resultCode === 200) {
                alert("초기화되었습니다.");
            } else {
                alert("초기화에 실패하였습니다.");
            }
        });
    };

    const selectUserId = (e) => {
        const selectedId = e.target.value; // 선택된 사용자 ID 가져오기
        setId(selectedId); // 상태 업데이트
        setIsChecked(true); // 선택된 ID가 있을 때 isChecked 상태 업데이트
    }

    const inputUserId = (e) => {
        const inputId = e.target.value; // 입력된 사용자 ID 가져오기
        setId(inputId); // 상태 업데이트
        setIsChecked(false);
    }

    // 셀렉트를 클릭했을 때, id값을 가져와서 setId에 넣어줌
    

    return (
        <div className="login-container">
            <form className="login-box">
                <div className="box-tit">계정관리</div>
                <ul>
                    <li className="li-flex">
                        <span className="id-icon">아이디</span>
                        <label htmlFor="id" className="visually-hidden">아이디</label>
                        <select id="select-id" name="select-id"
                            className="form-control login-form"
                            onChange={selectUserId}
                            value={id} // select와 상태 동기화
                        >   
                            <option value="">아이디 선택</option>
                            {userList.map((user, index) => (
                                 <option key={`${user.userId}-${index}`} value={user.userId}>{user.userId}</option>
                            ))}
                        </select>
                        <input
                            type="text" id="input-id" name="input-id"
                            className="form-control login-form"
                            value={id} // input과 상태 동기화
                            onChange={inputUserId}
                        />
                    </li>
                    {!isChecked &&
                    <li className="li-flex">
                        <span className="password-icon">비밀번호</span>
                        <label htmlFor="password" className="visually-hidden">비밀번호</label>
                        <input
                            type="password" id="password" name="password"
                            className="form-control login-form"
                            defaultValue={password}
                            onChange={(e) => setPassword(e.target.value)}
                        />
                    </li>
                    }
                    {!isChecked ? (
                        <li>
                            <button type="submit" className="btn login-btn" onClick={createHandler}>등록</button>
                        </li>                    
                        ) : (
                        <li>
                            <button type="submit" className="btn edit-btn" onClick={resetHandler}>초기화</button>
                        </li>
                    )}
                </ul>
                <div className="bg"></div>
            </form>
        </div>
    );
}

export default Account;
